module.exports = __webpack_public_path__ + "img/nkp-logo-en.bee737d6.svg";